import {
  Shield, Timer, BugOff, Umbrella, Ruler, Crosshair, Building2, Wrench, DoorOpen, Landmark,
} from "lucide-react";
import { SectionHeading } from "../components/SectionHeading";
import { Reveal } from "../components/Reveal";
import { WHY_STEEL } from "../data/site";

const ICONS = { Shield, Timer, BugOff, Umbrella, Ruler, Crosshair, Building2, Wrench, DoorOpen, Landmark };

export const WhySteel = () => (
  <section id="why-steel" data-testid="why-steel-section" className="bg-white py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHeading
        kicker="Why Steel"
        title="Why Choose Steel Door Frames?"
        desc="Pressed galvanized steel outperforms conventional frame materials on strength, stability and service life — without inflated claims."
      />
      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-px bg-black/10 border border-black/10">
        {WHY_STEEL.map((b, i) => {
          const Icon = ICONS[b.icon];
          return (
            <Reveal key={b.title} delay={(i % 5) * 0.06} className="bg-white">
              <div
                data-testid={`why-steel-card-${i}`}
                className="group h-full p-6 sm:p-7 hover:bg-brand-mist transition-colors duration-300"
              >
                <Icon className="w-7 h-7 text-brand-red transition-transform duration-300 group-hover:-translate-y-1" strokeWidth={1.75} />
                <h3 className="mt-5 font-display text-base font-semibold uppercase tracking-wide text-brand-ink leading-snug">
                  {b.title}
                </h3>
                <p className="mt-2.5 text-sm text-brand-ink/55 leading-relaxed">{b.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
